import { i18n } from '@/i18n';
import { isTaskCompleted } from '@/store/task';
import { TaskItem, TaskStatus } from '@/types/task';
import { TaskInfo } from '@tencent/wphk-act-base-cgi';
import { computed } from '@vue/composition-api';
import Decimal from 'decimal.js';
type MultiQualTaskInfo = Pick<TaskInfo, 'requiredCount' | 'requiredType' | 'totalCnt'> & Pick<TaskItem, 'status'>;

export const useMultiCountTask = (multiQualTaskInfo: MultiQualTaskInfo) => {
  const needCount = computed(() => {
    const { requiredCount, totalCnt } = multiQualTaskInfo;
    return new Decimal(requiredCount).minus(totalCnt);
  });
  const tipsDesc = computed(() => ({
    descTotal: i18n('已累計消費totalCnt次。', { totalCnt: multiQualTaskInfo.totalCnt }),
    descNeedCount: i18n('再消費needCount次，可獲贈', { needCount: needCount.value }),
  }));
  const isShowTips = computed(() => {
    const { requiredCount, totalCnt, status } = multiQualTaskInfo;
    // 需要获得多个资格的任务才展示气泡
    const isMultiQualTask = requiredCount > 1;
    // 至少累计一次任务时才展示气泡
    const isTaskHalfDone = totalCnt > 0;
    // 如果任务已完成，则不展示气泡
    const isTaskDone = isTaskCompleted({ requiredCount, totalCnt });
    // 任务状态为进行中才展示气泡
    const isTaskInProgress = status === TaskStatus.inProgress;
    return isMultiQualTask && !isTaskDone && isTaskInProgress && isTaskHalfDone;
  });
  return {
    tipsDesc,
    isShowTips,
  };
};
